(function($) {

	var customCookieName = 'excuid';

	function getCookie(name) {
		var match = document.cookie.match(
			new RegExp('(^| )' + name + '=([^;]+)'));
		if (match) {
			return match[2];
		}
		else {
			return '';
		}
	}

	function setCookie(name, value, days) {
		var expires = '';
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = '; expires=' + date.toUTCString();
		}
		document.cookie = name + '=' + (value || '') + expires + '; path=/';
	}

	function generateUniqueId() {
		return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
			function(c) {
				var r = Math.random() * 16 | 0,
					v = c == 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
	}

	var userId = getCookie('_ga') || getCookie(customCookieName);

	if (!userId) {
		userId = generateUniqueId();
		setCookie(customCookieName, userId, 365); // Set custom cookie for 1
	                                              // year
	}

	var pageUrl = window.location.href; // Get current URL

	function getReferralSource() {
		return document.referrer
			? new URL(document.referrer).hostname
			: 'direct';
	}

	function getDeviceType() {
		const ua = navigator.userAgent;
		let deviceType = 'Desktop';

		if (/Mobi|Android|iPhone|iPad|iPod/.test(ua)) {
			deviceType = 'Mobile';
		}
		else if (/Tablet|iPad/.test(ua)) {
			deviceType = 'Tablet';
		}

		return deviceType;
	}

	// Function to fetch the user's IP address
	function getUserIP(callback) {
		fetch('https://api.ipify.org?format=json').
		then(response => response.json()).
		then(data => {
			callback(data.ip);  // Pass the IP address to the callback function
		}).
		catch(error => {
			console.error('Error fetching IP address:', error);
			callback(null);  // If there's an error, return null
		});
	}


	function sendCustomEvent() {
		getUserIP(function(userIP) {
			// Now send the AJAX request with or without the IP
			$.ajax({
				url: customEvent.ajax_url,
				method: 'POST',
				data: {
					action: 'custom_event',
					user_id: userId,
					event: 'page_view',
					url: pageUrl,
					device_category: getDeviceType(),
					source: getReferralSource(),
					request_ip: userIP || '',
				},
				success: function(response) {
					// if (response.success) {
					//   console.log('Success:', response.data);
					// } else {
					//   console.log('Error:', response.data);
					// }
				},
				error: function(jqXHR, textStatus, errorThrown) {
					// console.log('Request failed', textStatus, errorThrown);
				},
			});
		});
	}

	// Call the sendCustomEvent function to execute the AJAX call
	sendCustomEvent();

	document.addEventListener('wpcf7submit', function(e) {
		var form = e.target;
		var eventStatus = form.classList.contains('invalid')
			? 'error'
			: 'success';
		var errorMessage = eventStatus === 'error'
			? e.detail.apiResponse.message
			: '';
		sendCF7Event(e, eventStatus, errorMessage);
	});

	function sendCF7Event(e, eventStatus, errorMessage) {
		getUserIP(function(userIP) {
			var formData = {
				action: 'cf7_submission',
				user_id: userId,
				event_status: eventStatus,
				error_message: errorMessage,
				device_category: getDeviceType(),
				source: getReferralSource(),
				url: pageUrl,
				contact_form_id: e.detail.contactFormId ?? '',
				form_inputs: e.detail.inputs ?? {},
				request_ip: userIP || '',
			};

			$.ajax({
				url: customEvent.ajax_url,
				type: 'POST',
				data: formData,
				success: function(response) {
					// console.log('Success:', response);
				},
				error: function(xhr, status, error) {
					// console.log('Request failed:', error);
				},
			});
		});
	}

	// WPForms event
	function collectFormData(form) {
		var formData = {};
		$(form).find('input, select, textarea').each(function() {
			var $this = $(this);
			var name = $this.attr('id');
			var value = $this.val();

			if ($this.is('input[type="text"], input[type="email"], textarea') &&
				value ||
				$this.is('input[type="checkbox"]') && $this.is(':checked') ||
				$this.is('input[type="radio"]') && $this.is(':checked') ||
				$this.is('select') && value) {
				formData[name] = value;
			}
		});

		return formData;
	}

	function sendWPFormsEvent(formData, eventStatus, errorMessage) {
		getUserIP(function(userIP) {
			$.ajax({
				url: customEvent.ajax_url,
				type: 'POST',
				data: {
					action: 'wpforms_submission',
					user_id: userId,
					event_status: eventStatus,
					error_message: errorMessage,
					device_category: getDeviceType(),
					source: getReferralSource(),
					url: window.location.href,
					wpform_id: formData['wpforms-id'] ?? '',
					form_inputs: formData ?? {},
					request_ip: userIP || '',
				},
				success: function(response) {
					// console.log('Success:', response);
				},
				error: function(xhr, status, error) {
					// console.log('Ajax request failed:', error);
				},
			});
		});
	}

	$('.wpforms-form').
	on('wpformsAjaxSubmitSuccess wpformsAjaxSubmitError wpformsAjaxSubmitFailed',
		function(e) {
			var form = e.target;
			var formData = collectFormData(form);
			formData['wpforms-id'] = $('input[name="wpforms[id]"]', form).
			val() ?? '';

			var eventStatus = e.type === 'wpformsAjaxSubmitSuccess'
				? 'success'
				: 'error';
			var errorMessage = eventStatus === 'error'
				? 'Failed submission'
				: '';

			sendWPFormsEvent(formData, eventStatus, errorMessage);
		});

	var searchingFor = $('#exc-searching-for').text();

	if (searchingFor) {
		getUserIP(function(userIP) {
			$.ajax({
				url: customEvent.ajax_url,
				method: 'POST',
				data: {
					action: 'exc_search',
					user_id: userId,
					event: 'search',
					url: pageUrl,
					device_category: getDeviceType(),
					source: getReferralSource(),
					search_term: searchingFor,
					request_ip: userIP || '',
				},
				success: function(response) {
					// console.log('Success:', response);
				},
				error: function(jqXHR, textStatus, errorThrown) {
					// console.log('Request failed:', errorThrown);
				},
			});
		});
	}

})(jQuery);
